function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.0036 3.70952C16.063 3.28207 13.3047 1.12618 12.3518 0.311966C12.15 0.139593 11.85 0.139593 11.6482 0.311966C10.6952 1.12618 7.93704 3.28208 4.99641 3.70952C4.44988 3.78896 4.00001 4.23149 4.00001 4.78376L4.00002 10.2703C4.00002 15.5431 9.2864 18.6728 11.2646 19.6594C11.7299 19.8914 12.2701 19.8914 12.7354 19.6594C14.7136 18.6728 20 15.5431 20 10.2703V4.78386C20 4.23157 19.5501 3.78896 19.0036 3.70952Z",
  fill: "#FC8C41"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8785 5.89492C16.5539 5.44368 13.4366 3.15967 12.3798 2.3148C12.1582 2.13765 11.8418 2.13765 11.6202 2.3148C10.5633 3.15968 7.44611 5.44369 4.1215 5.89492C3.50584 5.97849 3.00001 6.47664 3.00001 7.09795L3.00002 12.7838C3.00002 18.7363 9.87455 22.0876 11.6072 22.8378C11.859 22.9467 12.1411 22.9467 12.3928 22.8378C14.1255 22.0876 21 18.7363 21 12.7838V7.09817C21 6.47685 20.4942 5.97849 19.8785 5.89492Z",
  stroke: "#131416",
  strokeWidth: 1.6875
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 14.5C9 14.5 10.125 16 12 16C13.875 16 15 14.5 15 14.5",
  stroke: "#131416",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 12C10.5523 12 11 11.5523 11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11C9 11.5523 9.44772 12 10 12Z",
  fill: "#131416"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14 12C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11C13 11.5523 13.4477 12 14 12Z",
  fill: "#131416"
});

function SvgShield(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "colored",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.1be5dd89.svg";
export { ForwardRef as ReactComponent };